import { useTranslation } from 'react-i18next';
import { ConfirmationModal } from '../UI';

interface DeleteStaffModalProps {
  staffName: string;
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
}

export const DeleteStaffModal = ({ staffName, onConfirm, onClose }: DeleteStaffModalProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmationModal
      title={t('config-staff-delete-title')}
      message={t('config-staff-delete-message', { name: staffName })}
      warning={t('config-staff-delete-warning')}
      cancelLabel={t('config-delete-template-cancel')}
      confirmLabel={t('config-delete-template-confirm')}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
};
